import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DomainTypes } from '../models/domain/domain-types';
import { Observable } from 'rxjs/Observable';
import { StatesDomain } from '../models/domain/states-domain';
import { DomainType } from '../models/enums/domain-enum';

@Injectable()
export class DomainService {
  constructor(protected http: HttpClient) {}

  get(domain: DomainType, personType?: string): Observable<Array<DomainTypes>> {
    const url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.domain +
      domain;

    if (personType) {
      const queryParams = new HttpParams().append('personType', personType);
      return this.http.get<Array<DomainTypes>>(url, {params: queryParams});
    }

    return this.http.get<Array<DomainTypes>>(url);
  }

  getStates(uf: string = null): Observable<Array<StatesDomain>> {
    // tslint:disable-next-line: prefer-const
    let url =
      environment.apiCadastroSettings.url +
      environment.apiCadastroSettings.domainStates;

    if (uf) {
      url += '/' + uf;
    }

    return this.http.get<Array<StatesDomain>>(url);
  }
}
